import _ from 'lodash';
import React, { Component } from 'react';
import { batch } from 'react-redux';

import {
    getUserSelectedCameraDeviceId
} from '../../../../../react/features/base/settings';
import {
    ACTION_SHORTCUT_TRIGGERED,
    createShortcutEvent,
    createToolbarEvent,
    sendAnalytics
} from '../../../analytics';
import { getConferenceTimestamp, setObjectFit } from '../../../base/conference';
import { getToolbarButtons } from '../../../base/config';
import { getPictureInPictureModeConfig } from '../../../base/config/functions.any';
import { openDialog, toggleDialog } from '../../../base/dialog';
import {
    getWindowWidth,
    isMobileResponsive
} from '../../../base/environment/utils';
import { translate } from '../../../base/i18n';
import {
    Icon,
    IconArrowLeft,
    IconArrowRight
} from '../../../base/icons';
import MeetHourJS, { MHRecordingConstants } from '../../../base/lib-meet-hour';
import { MEDIA_TYPE } from '../../../base/media';
import {
    getLocalParticipant,
    getParticipantById,
    getParticipants,
    getScreenshareParticipantIds,
    isLocalParticipantModerator,
    participantUpdated
} from '../../../base/participants';
import { connect } from '../../../base/redux';
import {
    isLocalCameraTrackMuted,
    isLocalTrackMuted,
    isRemoteTrackMuted,
    isScreenVideoShared
} from '../../../base/tracks';
import { getBackendSafeRoomName } from '../../../base/util';
import { isVpaasMeeting } from '../../../billing-counter/functions';
import { CHAT_SIZE, toggleChat } from '../../../chat';
import { setIsPollsTabFocused } from '../../../chat/actions.any';
import { closeChat, openChat } from '../../../chat/actions.web';
import {
    RESET_CLICKANDPLEDGE,
    clickPledgeDialog,
    resetClickandPledge,
    updateClickAndPledgeSession
} from '../../../clickandpledge-givent';
import { pollsTabFocusedHandler } from '../../../conference/actions.web';
import { handleToggleStageView, handleToolboxResponsiveFilmstrip } from '../../../conference/filmStripViewManager';
import { addDonorurl, donorboxDialog, toggleDonorbox } from '../../../donorbox';
import { EmbedMeetingDialog } from '../../../embed-meeting';
import { openFeedbackDialog } from '../../../feedback';
import { setGifMenuVisibility } from '../../../gifs/actions';
import { isGifEnabled } from '../../../gifs/function.any';
import { beginAddPeople } from '../../../invite';
import { openKeyboardShortcutsDialog } from '../../../keyboard-shortcuts';
import { showNotification, showWarningNotification } from '../../../notifications';
import {
    close as closeParticipantsPane,
    open as openParticipantsPane
} from '../../../participants-pane/actions';
import { getParticipantsPaneOpen } from '../../../participants-pane/functions';
import { addReactionToBuffer } from '../../../reactions/actions.any';
import { toggleReactionsMenuVisibility } from '../../../reactions/actions.web';
import { REACTIONS } from '../../../reactions/constants';
import {
    isReactionsEnabled,
    shouldDisplayReactionsButtons
} from '../../../reactions/functions.any';
import { getActiveSession } from '../../../recording';
import { startScreenShareFlow } from '../../../screen-share/actions.web';
import {
    SETTINGS_TABS,
    getAudioSettingsVisibility,
    getVideoSettingsVisibility,
    openSettingsDialog
} from '../../../settings';
import { toggleSharedVideo } from '../../../shared-video/actions';
import { SpeakerStats } from '../../../speaker-stats';
import { closeCaptionsModal } from '../../../subtitles/actions.web';
import {
    setTileView,
    shouldDisplayTileView,
    toggleTileView
} from '../../../video-layout';
import { VideoQualityDialog } from '../../../video-quality';
import { VoiceCommandDialog } from '../../../voice-command/components/web/VoiceCommandDialog';
import {
    setFullScreen,
    setOverflowMenuVisible
} from '../../actions';
import { setFloatToolboxHidden } from '../../actions.any';
import {
    sendWhiteBoardInstance,
    setShareMenuVisible
} from '../../actions.web';
import {
    togglezoom,
    togglezoomout
} from '../../functions';

import FixedViewFooter from './FixedViewFooter';
import FloatViewFooter, { ConferenceSideBar } from './FloatViewFooter';
import VCStringActionHandler from './VCStringActionHandler';


declare var config: Object;

/**
 * The type of the React {@code Component} props of {@link Toolbox}.
 */
type Props = {

    /**
     * Whether or not the chat feature is currently displayed.
     */
    _chatOpen: boolean,

    /**
     * Click and pledge token.
     */
    _clicknPledgeVisible: boolean,

    /**
     * The {@code MHConference} for the current conference.
     */
    _conference: Object,

    hview: string,

    /**
     * The tooltip key to use when screensharing is disabled. Or undefined
     * if non to be shown and the button to be hidden.
     */
    _desktopSharingDisabledTooltipKey: boolean,

    /**
     * Whether or not screensharing is initialized.
     */
    _desktopSharingEnabled: boolean,

    /**
     * Whether or not a dialog is displayed.
     */
    _dialog: boolean,

    /**
     * Donor box visibility in toolbox through jwt token.
     */
    _donorBoxVisible: boolean,

    /**
     * Display embed Meeting url button.
     */
    _embedMeeting: boolean,

    /**
     * Whether or not call feedback can be sent.
     */
    _feedbackConfigured: boolean,

    /**
     * Whether or not the app is currently in full screen.
     */
    _fullScreen: boolean,

    /**
     * Whether or not the tile view is enabled.
     */
    _tileViewEnabled: boolean,

    /**
     * Whether or not the current user is logged in through a JWT.
     */
    _isGuest: boolean,

    /**
     * Whether or not the current meeting belongs to a JaaS user.
     */
    _isVpaasMeeting: boolean,

    /**
     * The ID of the local participant.
     */
    _localParticipantID: String,

    /**
     * The subsection of Redux state for local recording.
     */
    _localRecState: Object,

    /**
     * The value for how the conference is locked (or undefined if not locked)
     * as defined by room-lock constants.
     */
    _locked: boolean,

    /**
     * ConfSettings in the conference settings.
     */
    confSettings: Object,

    /**
     * Whether or not the overflow menu is visible.
     */
    _overflowMenuVisible: boolean,

    /**
     * Whether or not the participants pane is open.
     */
    _participantsPaneOpen: boolean,

    /**
     * Whether or not the local participant's hand is raised.
     */
    _raisedHand: boolean,

    /**
     * Whether or not the local participant is screensharing.
     */
    _screensharing: boolean,

    /**
     * _ShareMenuVisibility.
     */
    _ShareMenuVisibility: boolean,

    /**
     * LiveStream Visible or not.
     */
    liveStreamVisible: boolean,

    /**
     * Room name.
     */
    _roomName: string,

    /**
     * Whether or not the local participant is sharing a YouTube video.
     */
    _sharingVideo: boolean,

    /**
     * Flag showing whether toolbar is visible.
     */
    _visible: boolean,

    /**
     * Set with the buttons which this Toolbox should display.
     */
    _visibleButtons: Set<string>,

    /**
     * Invoked to active other features of the app.
     */
    dispatch: Function,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,

    /**
     * Get Url for Donorbox.
     */
    _geturl: string,

    /**
     * Get Url for click and pledge.
     */
    clickAndPledgeUrl: string,

    /**
     * Is Owner Sharing Video.
     */
    _isOwnSharingVideo: boolean,

    /**
     * Add Url for Donorbox.
     */
    _addurl: string,

    /**
     * Recording is Visible.
     */
    RecordingVisible: boolean,

    /**
     * Is Moderator.
     */
    _isModerator: Boolean,

    /**
     * Detects Mobile Browser.
     */
    _isMobile: boolean,

    /**
     * Width of the Clients Browser.
     */
    _clientWidth: number,

    _videoMuted: boolean,

    /**
     * Share Status.
     */
    _sharingWhiteBoard: boolean,
    _shareEtherpad: boolean,
    _shareVideoState: boolean,
    _partId: ?boolean,
    _etherpadPart: ?boolean,
    _isWhiteBoardID: ?string,
    _isetherPadId: ?string,
    _whiteBoardvisible: ?boolean,
    _localId: ?string,
    _isOpenP: ?boolean,
    _livePadVisible: ?boolean,
    _vcString: ?string,
    _isLiveStreamRunning: ?boolean,
    iframeVisible: ?boolean,
    onEdit: ?boolean,
    _isRecordingRunning: ?boolean,
    vcVisible: ?boolean,
    _screenShareVisible: ?boolean,

    /**
     * Voice command hide.
     */
    _isVoiceCommandDisabled: ?boolean,

    /*
     * isGIF Enabled
     */
    _isGifEnabled: boolean,

    /**
     * Is Transcriber on.
     */
    _requestingSubtitles: boolean,

    /**
     * ShouldDisplayReactionsButtons.
     */
    _shouldDisplayReactionsButtons: boolean,

    /**
     * Is Reactions Enabled.
     */
    _reactionsEnabled: boolean,

    _isPollsTabFocused: boolean,

    /**
     * Whether or not the toolbox should be shown.
     */
    _showtoolbox: boolean,

    /**
     * The ID of the currently selected video input device.
     */
    _selectedVideoInputId: string,

    /**
     * PictureInPictureEnabled State
     */
    _isPictureInPictureEnabled: boolean,
};

/**
 * The type of the React {@code Component} state of {@link Toolbox}.
 */
type State = {

    /**
     * The width of the browser's window.
     */
    windowWidth: number,

    tileViewEnable: boolean,
    totalPages: number,
};

/* global APP, interfaceConfig */


/**
 * Implements the conference toolbox on React/Web.
 *
 * @augments Component
 */
class Toolbox extends Component<Props, State> {
    /**
     * Initializes a new {@code Toolbox} instance.
     *
     * @param {Props} props - The read-only React {@code Component} props with
     * which the new instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        // Bind event handlers so they are only bound once per instance.
        this._onResize = this._onResize.bind(this);
        this._onSetOverflowVisible = this._onSetOverflowVisible.bind(this);
        this._onSetShareScreenOverflowVisible
            = this._onSetShareScreenOverflowVisible.bind(this);
        this._onToggleWhiteBoard = this._onToggleWhiteBoard.bind(this);

        this._onShortcutToggleChat = this._onShortcutToggleChat.bind(this);
        this._onShortcutToggleFullScreen
            = this._onShortcutToggleFullScreen.bind(this);
        this._onShortcutToggleParticipantsPane
            = this._onShortcutToggleParticipantsPane.bind(this);
        this._onShortcutToggleRaiseHand
            = this._onShortcutToggleRaiseHand.bind(this);
        this._onShortcutToggleScreenshare
            = this._onShortcutToggleScreenshare.bind(this);
        this._onShortcutToggleVideoQuality
            = this._onShortcutToggleVideoQuality.bind(this);
        this._onToolbarOpenFeedback = this._onToolbarOpenFeedback.bind(this);
        this._onToolbarOpenInvite = this._onToolbarOpenInvite.bind(this);
        this._onToolbarOpenKeyboardShortcuts
            = this._onToolbarOpenKeyboardShortcuts.bind(this);
        this._onRemoveClickandPledge = this._onRemoveClickandPledge.bind(this);
        this._onToolbarToggleParticipantsPane
            = this._onToolbarToggleParticipantsPane.bind(this);
        this._onToolbarOpenSpeakerStats
            = this._onToolbarOpenSpeakerStats.bind(this);
        this._onToolbarOpenEmbedMeeting
            = this._onToolbarOpenEmbedMeeting.bind(this);
        this._onToolbarOpenVideoQuality
            = this._onToolbarOpenVideoQuality.bind(this);
        this._onToolbarToggleChat = this._onToolbarToggleChat.bind(this);
        this._onToolbarTogglePolls = this._onToolbarTogglePolls.bind(this);
        this._onToolbarToggleFullScreen
            = this._onToolbarToggleFullScreen.bind(this);
        this._onShortcutToggleStageView = this._onShortcutToggleStageView.bind(this);
        this._onToolbarToggleProfile = this._onToolbarToggleProfile.bind(this);
        this._onToolbarToggleRaiseHand = this._onToolbarToggleRaiseHand.bind(this);
        this._onToolbarToggleScreenshare
            = this._onToolbarToggleScreenshare.bind(this);
        this._onToolbarToggleDonorbox = this._onToolbarToggleDonorbox.bind(this);
        this._onToolbarToggleclickandPledge
            = this._onToolbarToggleclickandPledge.bind(this);
        this._onToolbarToggleRemoveDonorbox
            = this._onToolbarToggleRemoveDonorbox.bind(this);
        this._onToolbarToggleVoiceCOmmandsDialog
            = this._onToolbarToggleVoiceCOmmandsDialog.bind(this);
        this._onToolbarToggleRemoveclickandPledge
            = this._onToolbarToggleRemoveclickandPledge.bind(this);
        this._onToolbarToggleSharedVideo
            = this._onToolbarToggleSharedVideo.bind(this);
        this._onShortcutToggleTileView = this._onShortcutToggleTileView.bind(this);
        this._onZoomIn = this._onZoomIn.bind(this);
        this._onZoomOut = this._onZoomOut.bind(this);
        this.handleConferenceSideBarView = this.handleConferenceSideBarView.bind(this);
        this._totalnoofPages = this._totalnoofPages.bind(this);
        this._onShortcutTogglePolls = this._onShortcutTogglePolls.bind(this);

        // Handler for SelectLabel viewStripMenu state changes
        this._onViewStripMenuChange = this._onViewStripMenuChange.bind(this);

        this.state = {
            windowWidth: (getWindowWidth() * 70) / 100,
            tileViewEnable: false,
            viewStripMenu: false,
            totalPages: 0
        };
    }

    /**
     * Sets keyboard shortcuts for to trigger ToolbarButtons actions.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        // Add document click listener to close overflow menu when clicking outside
        this._handleDocumentClick = this._handleDocumentClick.bind(this);
        document.addEventListener('click', this._handleDocumentClick);

        const KEYBOARD_SHORTCUTS = [
            this._shouldShowButton('videoquality') && {
                character: 'A',
                exec: this._onShortcutToggleVideoQuality,
                helpDescription: 'keyboardShortcuts.videoQuality'
            },
            this._shouldShowButton('chat') && {
                character: 'C',
                exec: this._onShortcutToggleChat,
                helpDescription: 'keyboardShortcuts.toggleChat'
            },
            this._shouldShowButton('desktop')
            && this.props._screenShareVisible && {
                character: 'D',
                exec: this._onShortcutToggleScreenshare,
                helpDescription: 'keyboardShortcuts.toggleScreensharing'
            },
            (this._shouldShowButton('stageview') || this._shouldShowButton('stage') || this._shouldShowButton('filmstrip')) && {
                character: 'F',
                exec: this._onShortcutToggleStageView,
                helpDescription: 'keyboardShortcuts.toggleFilmstripView'
            },
            this._shouldShowButton('poll') && {
                character: 'L',
                exec: this._onShortcutTogglePolls,
                helpDescription: 'keyboardShortcuts.togglePolls'
            },
            this._shouldShowButton('participants-pane') && {
                character: 'P',
                exec: this._onShortcutToggleParticipantsPane,
                helpDescription: 'keyboardShortcuts.toggleParticipantsPane'
            },
            this._shouldShowButton('raisehand') && {
                character: 'R',
                exec: this._onShortcutToggleRaiseHand,
                helpDescription: 'keyboardShortcuts.raiseHand'
            },
            this._shouldShowButton('fullscreen') && {
                character: 'S',
                exec: this._onShortcutToggleFullScreen,
                helpDescription: 'keyboardShortcuts.fullScreen'
            },
            this._shouldShowButton('tileview') && {
                character: 'W',
                exec: this._onShortcutToggleTileView,
                helpDescription: 'toolbar.tileViewToggle'
            }
        ];

        KEYBOARD_SHORTCUTS.forEach(shortcut => {
            if (typeof shortcut === 'object') {
                APP.keyboardshortcut.registerShortcut(
                    shortcut.character,
                    [],
                    shortcut.exec,
                    shortcut.helpDescription
                );
            }
        });

        if (
            this.props._reactionsEnabled
            && this.props._shouldDisplayReactionsButtons
        ) {
            const REACTION_SHORTCUTS = Object.keys(REACTIONS).map(key => {
                const onShortcutSendReaction = () => {
                    this.props.dispatch(addReactionToBuffer(key));
                    sendAnalytics(createShortcutEvent(`reaction.${key}`));
                };

                return {
                    character: REACTIONS[key].shortcutChar,
                    exec: onShortcutSendReaction,
                    helpDescription: `toolbar.reaction${key
                        .charAt(0)
                        .toUpperCase()}${key.slice(1)}`,
                    altKey: true
                };
            });

            REACTION_SHORTCUTS.forEach(shortcut => {
                APP.keyboardshortcut.registerShortcut(
                    `:${shortcut.character}`,
                    null,
                    shortcut.exec,
                    shortcut.helpDescription
                );
            });

            if (this.props._isGifEnabled) {
                const onGifShortcut = () => {
                    batch(() => {
                        this.props.dispatch(toggleReactionsMenuVisibility());
                        this.props.dispatch(setGifMenuVisibility(true));
                    });
                };

                APP.keyboardshortcut.registerShortcut({
                    character: 'G',
                    handler: onGifShortcut,
                    helpDescription: 'keyboardShortcuts.giphyMenu'
                });
            }
        }

        window.addEventListener('resize', this._onResize);

        this.props.dispatch(toggleDonorbox());

        if (document.body) {
            document.body.style.overflow = 'hidden';
        }
    }

    /**
     * Implements React's shouldComponentUpdate to prevent unnecessary rerenders.
     *
     * @param {Props} nextProps - The next props.
     * @param {State} nextState - The next state.
     * @returns {boolean} Whether the component should update.
     */
    shouldComponentUpdate(nextProps, nextState) {
        // Always update if state has changed
        if (this.state !== nextState) {
            return true;
        }

        // Check for critical props that should trigger a rerender
        const criticalProps = [
            '_visible',
            '_overflowMenuVisible',
            '_ShareMenuVisibility',
            '_chatOpen',
            '_isPollsTabFocused',
            '_participantsPaneOpen',
            '_raisedHand',
            '_screensharing',
            '_fullScreen',
            '_tileViewEnabled',
            '_isMobile',
            'hview',
            'filmStripView',
            'conferenceView',
            '_showtoolbox',

            // Share menu related props
            '_shareVideoState',
            '_whiteBoardvisible',
            '_livePadVisible',
            '_screenShareVisible',
            '_isLocalWhiteboard',
            '_isLocalEtherpad',
            '_localParticipantID',
            '_isWhiteBoardID',
            '_isetherPadId',
            '_isOwnSharingVideo',

            'desktopSharingEnabled',
            'giventToken',
            '_GiventOwnerId',
            '_clickandpledGUID',
            'floatToolboxHidden',
            '_isPictureInPictureEnabled'
        ];

        for (const prop of criticalProps) {
            if (this.props[prop] !== nextProps[prop]) {
                return true;
            }
        }

        // For overflow menu related props
        const overflowProps = [
            '_clicknPledgeVisible',
            '_donorBoxVisible',
            '_feedbackConfigured',
            '_geturl',
            'clickAndPledgeUrl',
            'liveStreamVisible',
            'RecordingVisible',
            '_isModerator',
            'vcVisible',
            '_isVoiceCommandDisabled',
            '_canEnableNoiseSuppression',
            'giventToken',
            '_GiventOwnerId',
            '_clickandpledGUID'
        ];

        for (const prop of overflowProps) {
            if (this.props[prop] !== nextProps[prop]) {
                return true;
            }
        }

        return false;
    }

    /**
     * Update the visibility of the {@code OverflowMenuButton}.
     *
     * @inheritdoc
     */
    componentDidUpdate(prevProps) {
        if (this.props._ShareMenuVisibility && (
            this.props._sharingWhiteBoard !== prevProps._sharingWhiteBoard
            || this.props._shareEtherpad !== prevProps._shareEtherpad
            || this.props._screensharing !== prevProps._screensharing
        )) {
            this.props.dispatch(setShareMenuVisible(false));
        }

        if (this.props._chatOpen !== prevProps._chatOpen) {
            this._onResize();
        }

        if (prevProps._sharingWhiteBoard !== this.props._sharingWhiteBoard) {
            if (this.props._sharingWhiteBoard && this.props._tileViewEnabled) {
                this.setState({ tileViewEnable: true });
                this.props.dispatch(setTileView(false));
            } else if (
                this.state.tileViewEnable
                && !this.props._sharingWhiteBoard
                && !this.props._tileViewEnabled
            ) {
                this.props.dispatch(setTileView(!this.props._tileViewEnabled));
            }
        }

        if (this.props._isModerator !== prevProps._isModerator) {
            if (this.props.confSettings !== null) {
                if (
                    this.props.confSettings.ENABLE_LOBBY === 1
                    && this.props._conference
                ) {
                    if (this.props.participantsLength === 1 && this.props._lobbyOverrideReceived === null) {
                        // Lobby toggle handled elsewhere
                    }
                }
            }
        }

        // FIX: PiP exit re-render — only trigger once when PiP is disabled,
        // not on every render. This prevents the infinite re-render loop.
        if (prevProps._isPictureInPictureEnabled && !this.props._isPictureInPictureEnabled) {
            setTimeout(() => {
                this.forceUpdate();
            }, 3000);
        }
    }

    /**
     * Removes keyboard shortcuts registered by this component.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        [ 'A', 'C', 'D', 'R', 'S' ].forEach(letter =>
            APP.keyboardshortcut.unregisterShortcut(letter)
        );

        window.removeEventListener('resize', this._onResize);

        if (this._handleDocumentClick) {
            document.removeEventListener('click', this._handleDocumentClick);
        }

        clearTimeout(this.timeout);
    }

    _onCaptionsArrowClick = () => {
        this.props.dispatch(closeCaptionsModal(!this.props._requestingCaptionsModal));
    };

    /**
     * Handles document click events to close overflow menu when clicking outside.
     *
     * @param {Event} event - The click event.
     * @private
     * @returns {void}
     */
    _handleDocumentClick = event => {
        if (!this.props._overflowMenuVisible) {
            return;
        }

        const toolboxElement = event.target.closest(
            '.toolbox-button-wth-dialog, .footer_conference, .conference-sidebar, .conference-bottom-bar'
        );

        if (!toolboxElement) {
            this.props.dispatch(setOverflowMenuVisible(false));
        }
    };

    handleConferenceSideBarView = () => {
        this.props.dispatch(setFloatToolboxHidden(!this.props.floatToolboxHidden));
    };

    /**
     * Handles the viewStripMenu state change from SelectLabel component.
     * @param {boolean} isVisible - The new visibility state of the viewStripMenu.
     * @returns {void}
     */
    _onViewStripMenuChange(isVisible) {
        this.setState({ viewStripMenu: isVisible });
    }

    /**
     * Callback to get total no of pages in tile view carousel and set it in state
     * @param {*} count - total no of pages in tile view carousel
     */
    _totalnoofPages(count) {
        this.setState({ totalPages: count });
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (
            <>
                <VCStringActionHandler />
                {this._renderToolboxContent()}
            </>
        );
    }

    /**
   * Callback invoked to display {@code FeedbackDialog}.
   *
   * @private
   * @returns {void}
   */
    _doOpenFeedback() {
        const { _conference } = this.props;

        this.props.dispatch(openFeedbackDialog(_conference));
    }

    /**
   * Callback invoked to display {@code FeedbackDialog}.
   *
   * @private
   * @returns {void}
   */
    _doOpenEmbedMeeting() {
        this.props.dispatch(openDialog(EmbedMeetingDialog));
    }

    /**
   * Dispatches an action to display {@code KeyboardShortcuts}.
   *
   * @private
   * @returns {void}
   */
    _doOpenKeyboardShorcuts() {
        this.props.dispatch(openKeyboardShortcutsDialog());
    }

    /**
   * Callback invoked to display {@code SpeakerStats}.
   *
   * @private
   * @returns {void}
   */
    _doOpenSpeakerStats() {
        this.props.dispatch(
            openDialog(SpeakerStats, {
                conference: this.props._conference
            })
        );
    }

    /**
   * Dispatches an action to open the video quality dialog.
   *
   * @private
   * @returns {void}
   */
    _doOpenVideoQuality() {
        this.props.dispatch(openDialog(VideoQualityDialog));
    }

    /**
   * Dispatches an action to toggle the display of chat.
   *
   * @private
   * @returns {void}
   */
    _doToggleChat() {
        this.props.dispatch(toggleChat());
    }

    /**
   * Dispatches an action to toggle screensharing.
   *
   * @private
   * @returns {void}
   */
    _doToggleFullScreen() {
        const fullScreen = !this.props._fullScreen;

        this.props.dispatch(setFullScreen(fullScreen));
    }

    /**
   * Dispatches an action to show or hide the profile edit panel.
   *
   * @private
   * @returns {void}
   */
    _doToggleProfile() {
        this.props.dispatch(openSettingsDialog(SETTINGS_TABS.PROFILE));
    }

    /**
   * Dispatches an action to toggle the local participant's raised hand state.
   *
   * @private
   * @returns {void}
   */
    _doToggleRaiseHand() {
        const now = Date.now();

        this._lastRaiseHandTimes = (this._lastRaiseHandTimes || []).filter(t => now - t < 10000);
        if (this._lastRaiseHandTimes.length >= 5) {
            const { dispatch, t } = this.props;

            dispatch(showWarningNotification({
                titleKey: t ? t('chat.raiseHandRateLimitKey') : 'chat.raiseHandRateLimitKey',
                description: t ? t('chat.raiseHandRateLimitMessage') : 'chat.raiseHandRateLimitMessage'
            }));

            return;
        }
        this._lastRaiseHandTimes.push(now);

        const { _localParticipantID, _raisedHand } = this.props;

        this.props.dispatch(
            participantUpdated({
                id: _localParticipantID,
                local: true,
                raisedHand: !_raisedHand
            })
        );
    }

    /**
   * Dispatches an action to toggle screensharing.
   *
   * @param {boolean} enabled - Desktop Sharing Enabled bool.
   * @private
   * @returns {void}
   */
    _doToggleScreenshare(enabled) {
        const { simultaneous_screen_sharing, screenSharingParticipants, _isModerator, t } = this.props;
        const noficiationDes = t('dialog.maxScreenSharingDes', { number: simultaneous_screen_sharing });
        const notifyGuestDes = t('dialog.maxScreenSharingGuestDes', { number: simultaneous_screen_sharing });

        if (enabled) {
            if (simultaneous_screen_sharing > screenSharingParticipants.length) {
                if (this.props._desktopSharingEnabled) {
                    this.props.dispatch(startScreenShareFlow(!this.props._screensharing));
                }
            } else if (_isModerator) {
                this.props.dispatch(
                    showNotification({
                        titleKey: 'dialog.maxScreenSharing',
                        descriptionKey: noficiationDes,
                        customActionNameKey: 'notify.upgradeNow',
                        customActionHandler: () => window.open(`${config?.URL_PREFIX}updateSubscription`, '_new')
                    })
                );
            } else {
                this.props.dispatch(
                    showNotification({
                        titleKey: 'dialog.maxScreenSharing',
                        descriptionKey: notifyGuestDes
                    })
                );
            }
        } else {
            this.props.dispatch(startScreenShareFlow(false));
        }
    }

    /**
   * Dispatches an action to toggle YouTube video sharing.
   *
   * @private
   * @returns {void}
   */
    _doToggleSharedVideo() {
        this.props.dispatch(toggleSharedVideo());
    }

    /**
   * Dispatches an action to toggle Donorbox Dialog box.
   *
   * @private
   * @returns {void}
   */
    _doToggleDonorboxDialog() {
        this.props.dispatch(toggleDialog(donorboxDialog));
    }

    /**
   * Dispatches an action to toggle Donorbox Dialog box.
   *
   * @private
   * @returns {void}
   */
    _doToggleCLPDialog() {
        this.props.dispatch(toggleDialog(clickPledgeDialog));
    }

    /**
   * Dispatches an action to toggle Donorbox Dialog box.
   *
   * @private
   * @returns {void}
   */
    _doRemoveDonorDialog() {
        this.props.dispatch(addDonorurl('remove'));
    }

    /**
   * Dispatches an action to toggle Voice Command Dialog box.
   *
   * @private
   * @returns {void}
   */
    _doOpenVoiceCommand() {
        this.props.dispatch(toggleDialog(VoiceCommandDialog));
    }

    /**
   * Dispatches an action to toggle Donorbox Dialog box.
   *
   * @private
   * @returns {void}
   */
    _doRemoveClpDialog() {
        this.props.dispatch(updateClickAndPledgeSession('remove'));
    }

    /**
   * Dispatches an action to toggle the video quality dialog.
   *
   * @private
   * @returns {void}
   */
    _doToggleVideoQuality() {
        this.props.dispatch(toggleDialog(VideoQualityDialog));
    }

    /**
   * Dispaches an action to toggle tile view.
   *
   * @private
   * @returns {void}
   */
    _doToggleTileView() {
        this.props.dispatch(toggleTileView());
    }

    // ─── Resize ─────────────────────────────────────────────────────────────────

    _onResize: () => void;

    /**
   * A window resize handler used to calculate the number of buttons we can
   * fit in the toolbar.
   *
   * @private
   * @returns {void}
   */
    _onResize() {
        let widthToUse = getWindowWidth();

        if (this.props._chatOpen) {
            widthToUse -= CHAT_SIZE;
        }

        if (this.state.windowWidth !== widthToUse) {
            this.setState({ windowWidth: widthToUse });
        }
    }

    // ─── Overflow & Share Menu Visibility ───────────────────────────────────────

    _onSetOverflowVisible: (boolean) => void;

    /**
   * Sets the visibility of the overflow menu.
   *
   * @param {boolean} visible - Whether or not the overflow menu should be
   * displayed.
   * @private
   * @returns {void}
   */
    _onSetOverflowVisible(visible) {
        this.props.dispatch(setOverflowMenuVisible(visible));
    }

    _onSetShareScreenOverflowVisible: (boolean) => void;

    /**
   * Sets the visibility of the overflow menu.
   *
   * @param {boolean} visible - Whether or not the overflow menu should be
   * displayed.
   * @private
   * @returns {void}
   */
    _onSetShareScreenOverflowVisible(visible) {
        this.props.dispatch(setShareMenuVisible(visible));
    }

    // ─── Keyboard Shortcuts ─────────────────────────────────────────────────────

    _onShortcutToggleChat: () => void;

    /**
   * Toggles the chat panel.
   *
   * @param {Object} e - The event object.
   * @private
   * @returns {void}
   */
    _onShortcutToggleChat(e) {
        if (e && (e.ctrlKey || e.metaKey)) {
            return;
        }
        sendAnalytics(
            createShortcutEvent('toggle.chat', {
                enable: !this.props._chatOpen
            })
        );
        this._doToggleChat();
    }

    _onShortcutToggleVideoQuality: () => void;

    /**
   * Creates an analytics keyboard shortcut event and dispatches an action for
   * toggling the display of Video Quality.
   *
   * @private
   * @returns {void}
   */
    _onShortcutToggleVideoQuality() {
        sendAnalytics(createShortcutEvent('video.quality'));
        this._doToggleVideoQuality();
    }

    _onShortcutToggleTileView: () => void;

    /**
   * Dispatches an action for toggling the tile view.
   *
   * @private
   * @returns {void}
   */
    _onShortcutToggleTileView() {
        sendAnalytics(
            createShortcutEvent('toggle.tileview', {
                enable: !this.props._tileViewEnabled
            })
        );
        this._doToggleTileView();
    }

    _onShortcutToggleFullScreen: () => void;

    /**
   * Creates an analytics keyboard shortcut event and dispatches an action for
   * toggling full screen mode.
   *
   * @private
   * @returns {void}
   */
    _onShortcutToggleFullScreen() {
        sendAnalytics(
            createShortcutEvent('toggle.fullscreen', {
                enable: !this.props._fullScreen
            })
        );
        this._doToggleFullScreen();
    }

    _onShortcutToggleRaiseHand: () => void;

    /**
   * Creates an analytics keyboard shortcut event and dispatches an action for
   * toggling the raise hand feature.
   *
   * @private
   * @returns {void}
   */
    _onShortcutToggleRaiseHand() {
        sendAnalytics(
            createShortcutEvent('toggle.raise.hand', ACTION_SHORTCUT_TRIGGERED, {
                enable: !this.props._raisedHand
            })
        );
        this._doToggleRaiseHand();
    }

    _onShortcutToggleScreenshare: () => void;

    /**
   * Creates an analytics keyboard shortcut event and dispatches an action for
   * toggling screensharing.
   *
   * @private
   * @returns {void}
   */
    _onShortcutToggleScreenshare() {
        const enable = !this.props._screensharing;

        sendAnalytics(
            createToolbarEvent('screen.sharing', { enable })
        );
        this._doToggleScreenshare(enable);
    }

    _onShortcutToggleParticipantsPane: () => void;

    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling the participants pane.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleParticipantsPane() {
        sendAnalytics(
            createShortcutEvent('toggle.participants-pane', {
                enable: !this.props._participantsPaneOpen
            })
        );
        this._onToolbarToggleParticipantsPane();
    }

    _onShortcutTogglePolls: () => void;

    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling the polls panel.
     *
     * @private
     * @returns {void}
     */
    _onShortcutTogglePolls() {
        this._onToolbarTogglePolls();
    }

    _onShortcutToggleStageView: () => void;

    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling the stage view.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleStageView() {
        handleToggleStageView(this.props.dispatch);
    }

    // ─── Toolbar Toolbar Event Handlers ─────────────────────────────────────────

    _onToolbarOpenFeedback: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for toggling
   * display of feedback.
   *
   * @private
   * @returns {void}
   */
    _onToolbarOpenFeedback() {
        sendAnalytics(createToolbarEvent('feedback'));
        this._doOpenFeedback();
    }

    _onToolbarOpenInvite: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for opening
   * the modal for inviting people directly into the conference.
   *
   * @private
   * @returns {void}
   */
    _onToolbarOpenInvite() {
        sendAnalytics(createToolbarEvent('invite'));
        this.props.dispatch(beginAddPeople());
    }

    _onToolbarOpenKeyboardShortcuts: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for opening
   * the modal for showing available keyboard shortcuts.
   *
   * @private
   * @returns {void}
   */
    _onToolbarOpenKeyboardShortcuts() {
        sendAnalytics(createToolbarEvent('shortcuts'));
        this._doOpenKeyboardShorcuts();
    }

    _onRemoveClickandPledge: () => void;

    /**
   * Dispatches an action for toggling the participants pane.
   *
   * @private
   * @returns {void}
   */
    _onRemoveClickandPledge() {
        this.props.dispatch(resetClickandPledge());

        const myid = this.props._conference.myUserId();

        const marqueeElements = document.querySelectorAll('.clickandpledge_marquee_parent');

        if (marqueeElements && marqueeElements.length > 0) {
            marqueeElements.forEach(elem => {
                elem.classList.remove('show');
                elem.classList.add('hide');
            });
        }

        this.props._conference.sendMessage({
            type: RESET_CLICKANDPLEDGE,
            myid,
            senderId: myid
        });
    }

    _onToolbarToggleParticipantsPane: () => void;

    /**
   * Dispatches an action for toggling the participants pane.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleParticipantsPane() {
        const { dispatch, _participantsPaneOpen } = this.props;

        if (_participantsPaneOpen) {
            dispatch(closeParticipantsPane());
        } else {
            dispatch(openParticipantsPane());
        }
    }

    _onToolbarOpenEmbedMeeting: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for opening
   * the embed meeting modal.
   *
   * @private
   * @returns {void}
   */
    _onToolbarOpenEmbedMeeting() {
        sendAnalytics(createToolbarEvent('embed.meeting'));
        this._doOpenEmbedMeeting();
    }

    _onToolbarOpenSpeakerStats: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for opening
   * the speaker stats modal.
   *
   * @private
   * @returns {void}
   */
    _onToolbarOpenSpeakerStats() {
        sendAnalytics(createToolbarEvent('speaker.stats'));
        this._doOpenSpeakerStats();
    }

    _onToolbarOpenVideoQuality: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for toggling
   * open the video quality dialog.
   *
   * @private
   * @returns {void}
   */
    _onToolbarOpenVideoQuality() {
        sendAnalytics(createToolbarEvent('video.quality'));
        this._doOpenVideoQuality();
    }

    _onToolbarToggleChat: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for toggling
   * the display of chat.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleChat() {
        const { _chatOpen, _isPollsTabFocused, dispatch } = this.props;

        sendAnalytics(
            createToolbarEvent('toggle.chat', {
                enable: !_chatOpen || _isPollsTabFocused
            })
        );

        if (_chatOpen) {
            if (_isPollsTabFocused) {
                dispatch(pollsTabFocusedHandler(false));
                dispatch(setIsPollsTabFocused(false));
            } else {
                dispatch(closeChat());
            }
        } else {
            dispatch(openChat());
            dispatch(pollsTabFocusedHandler(false));
            dispatch(setIsPollsTabFocused(false));
        }
    }

    _onToolbarTogglePolls: () => void;

    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * the polls panel.
     *
     * @private
     * @returns {void}
     */
    _onToolbarTogglePolls() {
        const { _chatOpen, _isPollsTabFocused, dispatch } = this.props;

        if (_chatOpen) {
            if (_isPollsTabFocused) {
                dispatch(closeChat());
            } else {
                dispatch(pollsTabFocusedHandler(true));
                dispatch(setIsPollsTabFocused(true));
            }
        } else {
            dispatch(openChat());
            dispatch(pollsTabFocusedHandler(true));
            dispatch(setIsPollsTabFocused(true));
        }
    }

    _onToolbarToggleFullScreen: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for toggling
   * full screen mode.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleFullScreen() {
        sendAnalytics(
            createToolbarEvent('toggle.fullscreen', {
                enable: !this.props._fullScreen
            })
        );
        this._doToggleFullScreen();
    }

    _onToggleWhiteBoard: () => void;

    /**
   * Toggle White Board.
   *
   * @private
   * @returns {void}
   */
    _onToggleWhiteBoard() {
        this.props.dispatch(sendWhiteBoardInstance(true));
    }

    _onToolbarToggleProfile: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for toggling
   * the profile settings.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleProfile() {
        sendAnalytics(createToolbarEvent('profile'));
        this._doToggleProfile();
    }

    _onToolbarToggleRaiseHand: () => void;

    /**
   * Creates an analytics toolbar event and dispatches an action for toggling
   * the local participant's raised hand state.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleRaiseHand() {
        sendAnalytics(
            createToolbarEvent('raise.hand', { enable: !this.props._raisedHand })
        );
        this._doToggleRaiseHand();
    }

    _onToolbarToggleScreenshare: () => void;

    /**
     *  Creates an analytics toolbar event and dispatches an action for toggling
     *  screensharing.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleScreenshare() {
        if (!this.props._desktopSharingEnabled) {
            return;
        }
        const enable = !this.props._screensharing;

        sendAnalytics(
            createShortcutEvent('toggle.screen.sharing', ACTION_SHORTCUT_TRIGGERED, { enable })
        );
        this._doToggleScreenshare(enable);
    }

    _onZoomIn: () => void;

    /**
   * Opens the {@code VideoZoomoutOnClick}.
   *
   * @private
   * @returns {void}
   */
    _onZoomIn() {
        sendAnalytics(createToolbarEvent('video-zoom.zoomin'));
        this.props.dispatch(togglezoom(1));
    }

    _onZoomOut: () => void;

    /**
   * Opens the {@code VideoZoomoutOnClick}.
   *
   * @private
   * @returns {void}
   */
    _onZoomOut() {
        sendAnalytics(createToolbarEvent('video-zoom.zoomout'));
        this.props.dispatch(togglezoomout(1));
    }

    /**
     * Toggles the object fit of the participant's video.
     * @private
     * @returns {void}
     */
    _onToggleObjectFit() {
        this.props.dispatch(
            setObjectFit(
                this.props._objectFit === 'cover' ? 'contain' : 'cover'
            )
        );
    }

    /**
   * Creates an analytics toolbar event and dispatches an action for toggling
   * the sharing of a YouTube video.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleSharedVideo() {
        sendAnalytics(
            createToolbarEvent('shared.video.toggled', {
                enable: !this.props._sharingVideo
            })
        );
        this._doToggleSharedVideo();
    }

    _onToolbarToggleDonorbox: () => void;

    /**
   * Creates dispatches an action for toggling
   * the sharing of a donate button across the conference.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleDonorbox() {
        this._doToggleDonorboxDialog();
    }

    _onToolbarToggleclickandPledge: () => void;

    /**
   * Creates dispatches an action for toggling
   * the sharing of a donate button across the conference.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleclickandPledge() {
        this._doToggleCLPDialog();
    }

    _onToolbarToggleRemoveDonorbox: () => void;

    /**
   * Creates dispatches an action for toggling
   * the removing the donorbox url.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleRemoveDonorbox() {
        this._doRemoveDonorDialog();
    }

    _onToolbarToggleVoiceCOmmandsDialog: () => void;

    /**
   * Creates dispatches an action for toggling
   * the dialog for Voice Commands.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleVoiceCOmmandsDialog() {
        this._doOpenVoiceCommand();
    }

    _onToolbarToggleRemoveclickandPledge: () => void;

    /**
   * Creates dispatches an action for toggling
   * the removing the donorbox url.
   *
   * @private
   * @returns {void}
   */
    _onToolbarToggleRemoveclickandPledge() {
        this._doRemoveClpDialog();
    }

    // ─── Helpers ────────────────────────────────────────────────────────────────

    _shouldShowButton: (string) => boolean;

    /**
     * Helper function to check if a button should be shown based on the _visibleButtons prop.
     * @param {} buttonName - The name of the button to check visibility for.
     * @returns {boolean} - True if the button should be shown, false otherwise.
     */
    _shouldShowButton(buttonName) {
        return this.props._visibleButtons.has(buttonName);
    }

    /**
   * Returns true if the desktop sharing button should be visible and
   * false otherwise.
   *
   * @returns {boolean}
   */
    _isDesktopSharingButtonVisible() {
        const { _desktopSharingEnabled, _desktopSharingDisabledTooltipKey } = this.props;

        return _desktopSharingEnabled || _desktopSharingDisabledTooltipKey;
    }

    // ─── Shared Props Builder ───────────────────────────────────────────────────

    /**
     * Builds the shared props object passed to all sub-layout components.
     * Centralizes prop gathering so FixedViewFooter/FloatViewFooter get a single clean object.
     */
    _buildSharedProps() {
        return {
            totalPages: this.state.totalPages,
            t: this.props.t,
            floatToolboxHidden: this.props.floatToolboxHidden,

            // Callbacks
            onToggleRaiseHand: this._onToolbarToggleRaiseHand,
            onToggleChat: this._onToolbarToggleChat,
            onTogglePolls: this._onToolbarTogglePolls,
            onToggleParticipantsPane: this._onToolbarToggleParticipantsPane,
            onSetOverflowVisible: this._onSetOverflowVisible,
            onSetShareScreenOverflowVisible: this._onSetShareScreenOverflowVisible,
            onCaptionsArrowClick: this._onCaptionsArrowClick,
            onViewStripMenuChange: this._onViewStripMenuChange,
            onTotalPagesChange: this._totalnoofPages,
            onToggleScreenshare: this._onToolbarToggleScreenshare,
            onZoomIn: this._onZoomIn,
            onZoomOut: this._onZoomOut,
            onToggleObjectFit: this._onToggleObjectFit.bind(this),
            onHandleConferenceSideBarView: this.handleConferenceSideBarView,

            // Overflow callbacks
            onToggleProfile: this._onToolbarToggleProfile,
            onOpenVideoQuality: this._onToolbarOpenVideoQuality,
            onOpenSpeakerStats: this._onToolbarOpenSpeakerStats,
            onOpenEmbedMeeting: this._onToolbarOpenEmbedMeeting,
            onOpenFeedback: this._onToolbarOpenFeedback,
            onOpenKeyboardShortcuts: this._onToolbarOpenKeyboardShortcuts,
            onToggleDonorbox: this._onToolbarToggleDonorbox,
            onRemoveDonorbox: this._onToolbarToggleRemoveDonorbox,
            onToggleClickAndPledge: this._onToolbarToggleclickandPledge,
            onRemoveClickAndPledge: this._onRemoveClickandPledge,
            onToggleVoiceCommands: this._onToolbarToggleVoiceCOmmandsDialog
        };
    }

    // ─── Render ─────────────────────────────────────────────────────────────────

    /**
     * Renders the toolbox content.
     *
     * @returns {Array<ReactElement>}
     */
    _renderToolboxContent() {
        const {
            _chatOpen,
            _isMobile,
            _visibleButtons,
            _isOpenP
        } = this.props;
        const tabletView = getWindowWidth() < 805;

        handleToolboxResponsiveFilmstrip(this.props.dispatch, this.props.filmStripView, _chatOpen || _isOpenP);

        const sharedProps = this._buildSharedProps();
        const isFixed = this.props.hview === 'fixed';
        const isFloat = this.props.hview === 'float';

        if (config?.iAmRecorder) {
            return null;
        }

        return (
            <>
                {/* Desktop Fixed Layout */}
                {!_isMobile && !tabletView && isFixed
                    && <FixedViewFooter { ...sharedProps } />}

                {/* Desktop Float Layout */}
                {!this.props._isPictureInPictureEnabled && !_isMobile && !tabletView && isFloat
                    && <FloatViewFooter { ...sharedProps } />}

                {/* Mobile/Tablet Fixed Layout — Sidebar */}
                {(_isMobile || tabletView) && isFixed && (
                    <div className = { `conference-sidebar-parent ${this.props.floatToolboxHidden ? 'visible' : ''}` }>
                        <div
                            className = 'conference-sidebar-icon'
                            onClick = { () => this.handleConferenceSideBarView() }>
                            <Icon
                                src = { this.props.floatToolboxHidden ? IconArrowRight : IconArrowLeft } />
                        </div>
                        <ConferenceSideBar { ...sharedProps } />
                    </div>
                )}

                {/* Mobile/Tablet Fixed Layout — Footer */}
                {(_isMobile || tabletView) && isFixed
                    && [ 'hangup', 'chat', 'polls', 'microphone', 'zoomin', 'zoomout', 'camera',
                        'desktop', 'invite', 'horizontalstrip', 'tileview', 'filmstrip' ].some(btn => _visibleButtons.has(btn))
                    && <FixedViewFooter { ...sharedProps } />}
            </>
        );
    }
}

/**
 * Maps (parts of) the redux state to {@link Toolbox}'s React {@code Component} props.
 *
 * @param {Object} state - The redux store/state.
 * @private
 * @returns {{}}
 */
export function mapStateToProps(state) {
    const { conference, locked, conferenceView, filmStripView, objectFit, isCustomParticipantVisible, isCustomParticipantEveryone } = state['features/base/conference'];

    const { _requestingCaptionsModal } = state['features/subtitles'];

    let desktopSharingEnabled = MeetHourJS.isDesktopSharingEnabled();
    const { callStatsID, enableFeaturesBasedOnToken, liveStreamingEnabled }
        = state['features/base/config'];
    const sharedVideoStatus = state['features/shared-video'].status;
    const { fullScreen, overflowMenuVisible, visibility, iframeVisible, labelsVisible, floatToolboxHidden }
        = state['features/toolbox'];
    const roomName = getBackendSafeRoomName(
        state['features/base/conference'].room
    );
    const { participantId } = state['features/large-video'];

    const { isOpen } = state['features/participants-pane'];
    const { getUrl, addUrl } = state['features/donorbox'];
    const {
        formGUID,
        clickAndPledgeUrl,
        giventToken,
        isEnabled,
        userId: _giventOwnerId
    } = state['features/clickandpledge'];
    const localParticipant = getLocalParticipant(state);
    const localRecordingStates = state['features/local-recording'];

    const { clientWidth } = state['features/base/responsive-ui'];
    const { voiceCommandString } = state['features/base/mtApi'];
    const { confSettings } = state['features/base/jwt'];
    let desktopSharingDisabledTooltipKey;
    let liveStreamVisible;
    let recStreamVisible;
    const isPersonModerator = isLocalParticipantModerator(state);
    const { feature = {} } = getLocalParticipant(state);
    const sharingWhiteBoard = state['features/genericiframe'].visible;
    const tracks = state['features/base/tracks'];

    const recSettings = confSettings
        ? isPersonModerator && confSettings?.ENABLE_RECORDING === 1
        : false;
    const livSettings = confSettings
        ? isPersonModerator && confSettings?.ENABLE_LIVESTREAM === 1
        : false;
    const { fileRecordingsEnabled } = state['features/base/config'];
    let isVideoMuted = true;
    const participant = participantId
        ? getParticipantById(state, participantId)
        : getLocalParticipant(state);

    if (participant?.local) {
        isVideoMuted = isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO);
    } else if (!participant?.isFakeParticipant) {
        isVideoMuted = isRemoteTrackMuted(tracks, MEDIA_TYPE.VIDEO, participantId);
    }
    liveStreamVisible = liveStreamingEnabled && livSettings && isPersonModerator;
    recStreamVisible = fileRecordingsEnabled && recSettings && isPersonModerator;

    if (typeof recStreamVisible === 'undefined') {
        recStreamVisible = fileRecordingsEnabled && recSettings && isPersonModerator;

        if (enableFeaturesBasedOnToken) {
            recStreamVisible = recStreamVisible && String(feature.recording) === 'true';
            if (!recStreamVisible) {
                recStreamVisible = true;
            }
        }
    }

    if (enableFeaturesBasedOnToken) {
        liveStreamVisible = liveStreamVisible && String(feature.livestreaming) === 'true';
        if (!liveStreamVisible) {
            liveStreamVisible = true;
        }
    }

    const toolbarButtons = getToolbarButtons(state);
    const {
        editing: shareEtherpad,
        partId: participantID,
        onEdit
    } = state['features/etherpad'];
    const liveStreamVisible1
        = (toolbarButtons.includes('livestreaming') && isPersonModerator) || liveStreamVisible;
    const RecordingVisible
        = (toolbarButtons.includes('recording') && isPersonModerator) || recStreamVisible;

    const buttons = new Set(toolbarButtons);

    let newbuttons = buttons;

    if (recStreamVisible && !buttons.has('localrecording')) {
        newbuttons = buttons.add('localrecording');
    }

    const LocalRecordingVisible
        = toolbarButtons.includes('localrecording') && isPersonModerator;

    if (enableFeaturesBasedOnToken) {
        desktopSharingEnabled
            = getParticipants(state).find(
                ({ features = {} }) => String(features['screen-sharing']) === 'true'
            ) !== undefined;
        desktopSharingDisabledTooltipKey = 'dialog.shareYourScreenDisabled';
    }

    const simultaneous_screen_sharing = state['features/base/mtApi']?.pregData?.simultaneous_screen_sharing;
    const embedMeeting = confSettings
        ? Boolean(confSettings?.ENABLE_EMBEED_MEETING === 1 && isPersonModerator)
        : false;
    const donorBoxVisible = confSettings
        ? confSettings?.DONOR_BOX === 1 && isPersonModerator
        : false;
    const clicknPledgeVisible = confSettings
        ? confSettings?.CP_CONNECT === 1 && isPersonModerator
        : false;
    const livePadVisible = confSettings
        ? confSettings?.LIVEPAD === 1 && isPersonModerator
        : false;
    const whiteBoardvisible = confSettings
        ? confSettings?.WHITE_BOARD === 1 && isPersonModerator
        : false;
    const screenShareVisible
        = _.isNil(confSettings)
            ? true : Boolean(
            isPersonModerator
            || !(confSettings?.DISABLE_SCREEN_SHARING_FOR_GUEST === 1)
            );
    const { partId } = state['features/genericiframe'];
    const participants = state['features/base/participants'];
    const participantLocal
        = participants.filter(i => i.local === true)[0]?.id === partId;
    const partTrue
        = participants.filter(i => i.local === true)[0]?.id === participantID;
    const localId = participants.filter(i => i.local === true)[0];
    const isAudioVideoSettingsOpen = getAudioSettingsVisibility(state) || getVideoSettingsVisibility(state);

    const isVoiceCommandDisabled = Boolean(
        interfaceConfig?.DISABLE_VOICE_COMMAND || !isPersonModerator
    );

    const shareVideoState = [ 'playing', 'pause', 'start' ].includes(
        sharedVideoStatus
    );
    const desktopApp = state['features/base/mtApi'].desktopapp;
    const screenSharing = Boolean(tracks.find(
        track => track.videoType === 'desktop' && track.muted === false
    ));
    const carouselStartIndex = state['features/filmstrip']?.visibleParticipantsStartIndex || 0;

    const screenShareDisabledForGuest = state['features/base/jwt'].confSettings?.DISABLE_SCREEN_SHARING_FOR_GUEST;
    const _selectedVideoInputId = getUserSelectedCameraDeviceId(state);

    const { conferenceTime } = state['features/base/conference'];
    const isDeskTop = interfaceConfig.ENABLE_DESKTOP_DEEPLINK === false && desktopApp === 1;

    return {
        _chatOpen: state['features/chat'].isOpen,
        _clientWidth: clientWidth,
        _clicknPledgeVisible: clicknPledgeVisible,
        _conference: conference,
        _desktopSharingEnabled: desktopSharingEnabled,
        _desktopSharingDisabledTooltipKey: desktopSharingDisabledTooltipKey,
        _dialog: Boolean(state['features/base/dialog'].component),
        _donorBoxVisible: donorBoxVisible,
        _feedbackConfigured: Boolean(callStatsID),
        _isGuest: state['features/base/jwt'].isGuest,
        _requestingCaptionsModal,
        _isVpaasMeeting: isVpaasMeeting(state),
        _isLocalWhiteboard: partId === localParticipant.id,
        _isLocalEtherpad: participantID === localParticipant.id,
        _embedMeeting: embedMeeting,
        _fullScreen: fullScreen,
        _tileViewEnabled: shouldDisplayTileView(state),
        _clickandpledGUID: formGUID,
        _localParticipantID: localParticipant.id,
        _localRecState: localRecordingStates,
        _locked: locked,
        _isLiveStreamRunning: Boolean(
            getActiveSession(state, MHRecordingConstants.mode.STREAM)
        ),
        _isRecordingRunning: Boolean(
            getActiveSession(state, MHRecordingConstants.mode.FILE)
        ),
        _overflowMenuVisible: overflowMenuVisible,
        _raisedHand: localParticipant.raisedHand,
        _screensharing: isScreenVideoShared(state),
        isCustomParticipantVisible,
        isCustomParticipantEveryone,
        _ShareMenuVisibility: visibility,
        _geturl: getUrl,
        desktopApp: isDeskTop,
        _addurl: addUrl,
        _screenShareDisabled: screenShareDisabledForGuest && !isPersonModerator,
        clickAndPledgeUrl,
        _isMobile: isMobileResponsive(),
        _isOpenP: isOpen,
        _isModerator: isPersonModerator,
        liveStreamVisible: liveStreamVisible1,
        _partId: participantLocal,
        confSettings,
        _videoMuted: isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO),
        RecordingVisible,
        LocalRecordingVisible,
        _showVideoMutedIndicator: isVideoMuted && !participant?.isFakeParticipant,
        _roomName: roomName,
        _participantsPaneOpen: getParticipantsPaneOpen(state),
        _sharingVideo:
            sharedVideoStatus === 'playing'
            || sharedVideoStatus === 'start'
            || sharedVideoStatus === 'pause',
        _visible: true,
        _isClickandPledgeEnabled: isEnabled,
        _visibleButtons: newbuttons,
        _sharingWhiteBoard: sharingWhiteBoard,
        _shareEtherpad: shareEtherpad,
        _shareVideoState: shareVideoState,
        _isOwnSharingVideo: localParticipant?.id === state['features/shared-video']?.ownerId,
        _etherpadPart: partTrue,
        _isWhiteBoardID: partId,
        _isetherPadId: participantID,
        _whiteBoardvisible: whiteBoardvisible,
        _livePadVisible: livePadVisible,
        _localId: localId,
        _vcString: voiceCommandString,
        vcVisible: !isLocalCameraTrackMuted(state['features/base/tracks']),
        iframeVisible,
        onEdit,
        giventToken,
        _screenShareVisible: screenShareVisible,
        _isVoiceCommandDisabled: isVoiceCommandDisabled,
        _isGifEnabled: isGifEnabled(state),
        _shouldDisplayReactionsButtons: shouldDisplayReactionsButtons(state),
        _reactionsEnabled: isReactionsEnabled(state),
        _isPollsTabFocused: state['features/chat'].isPollsTabFocused,
        _conferenceTime: conferenceTime,
        _startTimestamp: getConferenceTimestamp(state),
        conferenceView,
        filmStripView,
        _objectFit: objectFit,
        participantsLength: participants.length,
        isAudioVideoSettingsOpen,
        screensharing: screenSharing,
        participantId,
        participant,
        simultaneous_screen_sharing,
        floatToolboxHidden,
        _showtoolbox: labelsVisible,
        _GiventOwnerId: _giventOwnerId,
        screenSharingParticipants: getScreenshareParticipantIds(state),
        _selectedVideoInputId,
        _carouselStartIndex: carouselStartIndex,
        _isPictureInPictureEnabled: getPictureInPictureModeConfig(state),
        _lobbyOverrideReceived: state['features/lobby'].lobbyOverrideReceived
    };
}

export default translate(connect(mapStateToProps)(Toolbox));
